import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CuentasBancarias } from '../ctas';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompanyDataObject } from '../../cuentas-bancarias';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { InfoCuentasDialog } from '../info-cuentas-dialog/info-cuentas-dialog';
import { SettingsService } from '../../../settings/settings.service';
import { InputDialog } from '../../input-dialog/dialog-input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';


@Component({
    selector: 'create-cuenta-bancaria',
    templateUrl: './createacc.component.html',
    styleUrls: ['./createacc.component.less'],
    standalone: true,
    imports: [
      FormsModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      CommonModule,
      MatButtonModule,
      MatDialogModule,
      MatOptionModule,
      MatAutocompleteModule,
      MatInputModule,
      MatSelectModule,
      MatSlideToggleModule,
      MatIconModule
      
    ]
})
export class CreateAccCompanyDialog implements OnInit {
  public info!: CuentasBancarias;
  run: any;
  full_name: any;
  dialog_open: boolean = false;
  @Input() companyRun!: string;
  @Input() load_data: any;

  parent: any;
  @Output() loadCompany = new EventEmitter<CompanyDataObject>();

  @Input() id_company: any;
  @Input() token: any;

  @Output() funciones = new EventEmitter<number>();

  disabledButton: boolean = false;
  showSpinner: boolean = false;

  @Input() bancos: any[] = [];

  @Input() cuentas: any[] = [];

  valForm: FormGroup;

  is_tercero: boolean = false;
  placeholder!: string;
  email: any;

  file: any;
  //autocomplete select
  myControl = new FormControl();
  filteredOptions: Observable<any[]> | undefined;
  bank_selected: any;

  @Output() irAPrimeraTab = new EventEmitter<void>();


  constructor(
    fb: FormBuilder,
    public snackBar: MatSnackBar,
    public settings: SettingsService,
    public dialog: MatDialog,
    private change: ChangeDetectorRef

  ) {
    let rutValid = new FormControl(
      null,
      Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{7,10}[-][0-9K]$'),
      ])
    );
    let accNumber = new FormControl(
      null,
      Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{4,12}$'),
      ])
    );

    let emailValid = new FormControl(
      '',
      Validators.compose([
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')
      ])
    );

    let bankControl = new FormControl('', Validators.required);

    this.valForm = fb.group({
      bank: bankControl,
      type: ['', Validators.compose([Validators.required])],
      rut: rutValid,
      number: accNumber,
      name: ['', Validators.compose([Validators.required])],
      tercero: new FormControl(''),
      email: emailValid,
      file: [''],
      placeholderFile: new FormControl('')
    });
    this.valForm.controls['tercero'].setValue(false);


  }

  @Input() is_giro: boolean = false;
  async submitForm($ev: any, value: any) {
    $ev.preventDefault();

    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }

    if (this.valForm.valid) {
      this.disabledButton = true;
      this.showSpinner = true;
      const formData = new FormData();

      if (this.file && this.valForm.controls['tercero'].value == true) {
        formData.append('file', this.file);
      } 

      formData.append('bank', this.bank_selected);
      formData.append('email', value.email);
      formData.append('company_id', this.id_company)
      formData.append('tercero', this.valForm.controls['tercero'].value)
      for (let key in value) {
        if (key !== 'file' && key !== 'bank' && key !== 'email') {
          formData.append(key, value[key]);
        }
      }

      console.log("AQUI VALUE DE BANK", value.bank);

      if(!this.bank_selected) {
        this.valForm.controls['bank'].setErrors({"selected": true});
        this.disabledButton = false;
        return;
      }

      try {
        const bd: any = await this.settings.get_query(
          2,
          'cliente-inversionista/bank-accounts/',
          formData
        );
        var body_data: any = bd._body;
        switch (bd.status) {
          case 201:
          case 200:
            this.disabledButton = false;
            this.showSpinner = false;

            this.infoCuentasDialog(
              "Cuenta creada",
              `Se creo la cuenta bancaria.`,
              "check_circle",
              "Cerrar"
            );

            this.is_tercero = false;
            this.valForm.get('placeholderFile')?.clearValidators();
            this.valForm.get('placeholderFile')?.updateValueAndValidity();
            this.irAPrimeraTab.emit();
            this.change.detectChanges(); 

            if (this.dialog_open == true) {
              this.parent.post_facturas();
            } else {
              //this.funciones.emit(1);
            }

            this.file = undefined;
            this.placeholder = "";
            this.ngOnInit();
            this.valForm.reset();

            break;
          default:
            break;
        }
      } catch (bd: any) {}
    }
  }


  toggleTerceroValidation() {
    if (this.is_tercero == true) {
      this.valForm.get('placeholderFile')?.setValidators([Validators.required]);
    } else {
      this.valForm.get('placeholderFile')?.clearValidators();
    }
    this.valForm.get('placeholderFile')?.updateValueAndValidity();
  }

  validate_error($event: any) {
    if (this.bank_selected == undefined) {
      this.valForm.controls['bank'].setValue('');
      this.valForm.controls['bank'].setErrors({ required: true });
      this.myControl.setValue('');
    }
  }

  filtrar_banco($e: any) {
    const selectedBank = this.bancos.find(bank => bank.name === $e.option.value);
    if (selectedBank) {
      this.bank_selected = selectedBank.id;
    }
    let cuenta = { id: '2', name: 'Cuenta RUT' };
    if (this.bank_selected != '26') {
      if (this.cuentas.indexOf(cuenta) != -1) {
        this.cuentas.splice(this.cuentas.indexOf(cuenta), 1);
      }
    } else {
      this.cuentas.push(cuenta);
    }
  }

  transform_number() {
    let regex = /[^0-9]+/;
    let phone = String(this.valForm.controls['number'].value).replace(
      regex,
      ''
    );
    if (phone != '') {
      return this.valForm.controls['number'].setValue(phone);
    } else {
      this.valForm.controls['number'].reset();
    }
  }

  ngOnInit() {
    console.log("AQUI BANCOS en create", this.bancos)
    console.log("AQUI CUENTAS en create", this.cuentas)
    // this.valForm.get('placeholderFile')?.disable()

  this.filteredOptions = this.valForm.get('bank')!.valueChanges.pipe(
    startWith(''),
    map(value => {
      if (!value || value === '') {
        return this.bancos;
      }
      return this._filter(value);
    })
  );
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.bancos.filter(
      (option) => option.name.toLowerCase().includes(filterValue) === true
    );
  }


  disableTerceroBtn: boolean = false;
  change_run() {
    let st = this.run.replace('-', '');
    let arr = st.split('');
    let st_out = '';

    for (let i = 0; i < arr.length; i++) {
      st_out = st_out + arr[i];

      if (i == arr.length - 2) {
        st_out = st_out + '-';
      }
    }
    if(this.companyRun != st_out && st_out.length >8){
      this.valForm.get('tercero')?.setValue(true);
      this.valForm.get('tercero')?.disable()
      this.is_tercero = true;
      this.toggleTerceroValidation()
    }
    else{
      this.valForm.get('tercero')?.setValue(false)
      this.is_tercero = false;
      this.toggleTerceroValidation();
    }

    this.run = st_out;
  }

  change_toggle($event:any){
    console.log($event.checked)
    if($event.checked == true){
      this.is_tercero = true;
      this.toggleTerceroValidation();
    }else{
      this.is_tercero = false;
      this.toggleTerceroValidation();
    }
  }

  change_toggle_custom($event:any){
    console.log($event)
  }


  onFileChange(event: any) {
    if (event.target.files.length > 0) {

      this.file = event.target.files[0];
      console.log('entre', this.file)
      this.placeholder = this.file.name;
    }
  }

  open_input_dialog(title:any,subtitle:any,mensajeprincipal:any, mensajenegrita:any,icon:any,coloricon:any) {
    const dialogRef = this.dialog.open(InputDialog, {
      width: '700px',
      autoFocus: false,
    });
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.subtitle = subtitle;
    dialogRef.componentInstance.mensajeprincipal = mensajeprincipal;
    dialogRef.componentInstance.mensajenegrita = mensajenegrita;
    dialogRef.componentInstance.icon = icon;
    dialogRef.componentInstance.coloricon = coloricon;
    dialogRef.afterClosed().subscribe((result) => {
    });
  }



// Función para formatear RUT en tiempo real
formatRutOnChange(event: any) {
  let rutValue = event.target.value || '';
  
  // Remover todo lo que no sea números o K/k
  rutValue = rutValue.replace(/[^0-9Kk]/g, '');
  
  // Convertir k minúscula a mayúscula
  rutValue = rutValue.replace(/k/g, 'K');
  
  // Separar números y dígito verificador
  if (rutValue.length > 1) {
    let numbers = rutValue.slice(0, -1);
    let verificador = rutValue.slice(-1);
    
    // Limitar a máximo 8 números antes del dígito verificador
    if (numbers.length > 8) {
      numbers = numbers.slice(0, 8);
    }
    
    // Formar RUT con guión
    rutValue = numbers + '-' + verificador;
  }
  
  // Actualizar el valor en el formulario
  this.valForm.controls['rut'].setValue(rutValue);
  this.run = rutValue;
  
  // Verificar si es tercero
  this.checkTerceroStatus(rutValue);
}

// Función para verificar si es cuenta de tercero
checkTerceroStatus(rutValue: string) {
  console.log("aqui rut del input", rutValue);
  console.log("Aqui valor del que viene de no se donde?", this.companyRun);
  if (this.companyRun.toLowerCase() !== rutValue.toLowerCase() ) {
    this.valForm.get('tercero')?.setValue(true);
    this.valForm.get('tercero')?.disable();
    this.is_tercero = true;
    this.placeholder = "";
    this.toggleTerceroValidation();
  } else {
    this.valForm.get('tercero')?.setValue(false);
    this.valForm.get('tercero')?.enable();
    this.placeholder = "";
    this.is_tercero = false;
    this.toggleTerceroValidation();
  }
}

// Función para formatear número de cuenta (solo números)
formatAccountNumberOnChange(event: any) {
  let accountValue = event.target.value || '';
  let cursorPosition = event.target.selectionStart;
  
  // Remover todo lo que no sea números
  let cleanValue = accountValue.replace(/[^0-9]/g, '');
  
  // Solo actualizar si el valor cambió
  if (accountValue !== cleanValue) {
    this.valForm.controls['number'].setValue(cleanValue, { emitEvent: false });
    
    // Restaurar posición del cursor
    setTimeout(() => {
      event.target.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  }
}

// Función para formatear nombre (solo letras y espacios)
formatNameOnChange(event: any) {
  let nameValue = event.target.value || '';
  let cursorPosition = event.target.selectionStart;
  
  // Remover números y caracteres especiales, mantener solo letras y espacios
  let cleanValue = nameValue.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]/g, '');
  
  // Solo actualizar si el valor cambió
  if (nameValue !== cleanValue) {
    this.valForm.controls['name'].setValue(cleanValue, { emitEvent: false });
    
    // Restaurar posición del cursor
    setTimeout(() => {
      event.target.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  }
}

// Función para limpiar email (remover espacios)
formatEmailOnChange(event: any) {
  let emailValue = event.target.value || '';
  let cursorPosition = event.target.selectionStart;
  
  // Remover espacios
  let cleanValue = emailValue.replace(/\s+/g, '');
  
  // Solo actualizar si el valor cambió
  if (emailValue !== cleanValue) {
    this.valForm.controls['email'].setValue(cleanValue, { emitEvent: false });
    
    // Restaurar posición del cursor
    setTimeout(() => {
      event.target.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  }
}

  infoCuentasDialog(title:any,subtitle:any,icon:any,buttonText:any) {
    const dialogRef = this.dialog.open(InfoCuentasDialog, {
      width: '500px',
      panelClass: 'custom-dialog',
      autoFocus: false,
    });
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = subtitle;
    dialogRef.componentInstance.icon = icon;
    dialogRef.componentInstance.buttonText = buttonText;
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

}
